import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Grid,
  Typography,
  Box,
  Modal,
  IconButton,
  ThemeProvider,
  Card,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { theme } from "antd";
import { DoctorconsoleGrid } from "../StyledComponents";
import { toast } from "react-toastify";
import { CheckToken } from "../../login/AccessToken";
import { AttachmentsFilePreview } from "./AttachmentsFilePreview";

const Attachments = ({
  sectionName,
  activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  setData,
}) => {
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [attachments, setAttachments] = useState(data);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    setAttachments(data);
  }, [data]);

  // const handleFileSelect = (acceptedFiles) => {
  //   Promise.all(
  //     acceptedFiles.map((file) => {
  //       return new Promise((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.onload = () => {
  //           resolve({
  //             name: file.name,
  //             type: file.type,
  //             size: file.size,
  //             base64: reader.result,
  //           });
  //         };
  //         reader.onerror = reject;
  //         reader.readAsDataURL(file);
  //       });
  //     })
  //   )
  //     .then((newAttachments) => {
  //       const formData = new FormData();
  //       formData.append("file_object", newAttachments);
  //       if (Token()) {
  //         axios
  //           .post(
  //             `${REACT_APP_BACKEND_ROUTE_URL}file_check_for_vulnerabilities/`,
  //             // formData,
  //             { file_object: newAttachments },
  //             {
  //               headers: headers,
  //             }
  //           )
  //           .then((res) => {
  //             console.log(res);
  //           })
  //           .catch((corruptError) => {
  //             console.error(
  //               "Error in file check for vulnerabilities:",
  //               corruptError
  //             );
  //           });
  //       }

  //       let newDetails = [...attachments, ...newAttachments];
  //       setAttachments(newDetails);
  //       setData(newDetails);
  //     })
  //     .catch((error) => {
  //       console.error("Error reading files:", error);
  //     });
  // };

  const handleFileSelect = (acceptedFiles) => {
    // Process files to extract base64 and raw data
    Promise.all(
      acceptedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              name: file.name,
              type: file.type,
              size: file.size,
              base64: reader.result, // Base64 string for UI
              rawFile: file, // Raw file for backend
            });
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      })
    )
      .then((fileDetails) => {
        // Create FormData and append all raw files
        const formData = new FormData();
        fileDetails.forEach((file) => {
          formData.append("file_object", file.rawFile); // Add each file
        });

        // Send files to the backend
        if (Token()) {
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}file_check_for_vulnerabilities/`,
              formData,
              {
                headers: {
                  ...headers,
                  "Content-Type": "multipart/form-data", // Required for file uploads
                },
              }
            )
            .then((res) => {
              console.log("Response:", res);
              if (res.data.status === "Success") {
                // Update state for UI (base64 data for previews, etc.)
                let newDetails = [...attachments, ...fileDetails];
                setAttachments(newDetails);
                setData(newDetails);
              } else if (res.data.status == "Failed") {
                if (res.data.message.includes("corrupted")) {
                  toast.error(
                    "The Attachment(s) uploaded is/are corrupted. Please try with a different document."
                  );
                } else if (res.data.message.includes("virus")) {
                  toast.error(
                    "The Attachment(s) uploaded has virus. Please try with a different document."
                  );
                } else {
                  toast.error(res.data.message);
                }
              }
            })
            .catch((error) => {
              console.error("Error in file check for vulnerabilities:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error processing files:", error);
      });
  };

  const handleRejectedFiles = (fileRejections) => {
    fileRejections.forEach((rejection) => {
      const { file, errors } = rejection;

      errors.forEach((error) => {
        if (error.code === "file-too-large") {
          toast.error(
            `The file "${file.name}" is too large. Maximum size allowed is 10 MB.`
          );
        } else if (error.code === "file-too-small") {
          toast.error(
            `The file "${file.name}" is too small. Minimum size allowed is 20 KB.`
          );
        } else if (error.code === "file-invalid-type") {
          toast.error(
            `The file "${file.name}" has an invalid file type. Accepted types are .pdf, .jpeg, .jpg, .png.`
          );
        }
      });
    });
  };
  const handleDeleteAttachment = (index) => {
    let newDetails = attachments.filter((_, ind) => index !== ind);
    console.log("Delete", index, newDetails);
    setAttachments(newDetails);
    setData(newDetails);
  };
  const [attachmentPreviewModalOpen, setAttachmentPreviewModalOpen] =
    useState(false);
  const [selectedAttachmentForPreview, setSelectedAttachmentForPreview] =
    useState(null);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    }, // Specify MIME types and extensions // Accepted file types
    multiple: true,
    maxSize: 10 * 1024 * 1024, // 10MB
    minSize: 20 * 1024, // 20kb
    onDrop: handleFileSelect,
    onDropRejected: handleRejectedFiles,
  });
  const handleAttachmentPreviewModalOpen = (attachment) => {
    setAttachmentPreviewModalOpen(true);
    setSelectedAttachmentForPreview(attachment);
  };
  const closeAttachmentPreviewModal = () => {
    setAttachmentPreviewModalOpen(false);
    setSelectedAttachmentForPreview(null);
  };
  console.log("Attachments", attachments);

  return (
    <ThemeProvider theme={theme}>
      {/* Drag and Drop Area */}
      <Card
        sx={{
          borderRadius: "10px",
          boxShadow: "0 4px 4px 0 #C7C7CC inset",
          backgroundColor: "#FFF",
        }}
      >
        {activeSection && (
          <DoctorconsoleGrid
            item
            xs={12}
            sx={{
              marginTop: "5px",
              padding: "10px",
            }}
          >
            <Box
              {...getRootProps()}
              sx={{
                marginBottom: 2,
                padding: 3,
                border: "2px dashed #21cdc0",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundImage: "url(/newImages/attachmentsBackground.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <input {...getInputProps()} />
              <Typography variant="h6" sx={{ marginBottom: 1 }}>
                Drag 'n' drop some files here, or click to select files
              </Typography>
            </Box>
          </DoctorconsoleGrid>
        )}

        {/* File Preview */}
        <AttachmentsFilePreview
          data={attachments}
          activeSection={activeSection}
          handleAttachmentPreviewModalOpen={handleAttachmentPreviewModalOpen}
          handleDeleteAttachment={handleDeleteAttachment}
          closeAttachmentPreviewModal={closeAttachmentPreviewModal}
          attachmentPreviewModalOpen={attachmentPreviewModalOpen}
          selectedAttachmentForPreview={selectedAttachmentForPreview}
        />
      </Card>
    </ThemeProvider>
  );
};

export default Attachments;
